import { useQuery } from '@tanstack/react-query';
import * as commerce from '@/api/commerce.api';

export function useBooks(enabled = true) {
  return useQuery({ queryKey: ['books'], queryFn: () => commerce.getBooks(), enabled });
}

export function useCartQuote(courseSlugs: string[], coupon: string | null) {
  return useQuery({
    queryKey: ['quote', courseSlugs, coupon],
    queryFn: () => commerce.getCartQuote(courseSlugs, coupon),
  });
}
